import Vue from 'vue' 
import App from './App.vue'
import router from './router'
import VueTailwind from 'vue-tailwind'
import Vue2Filters from 'vue2-filters'
import VueAnime from 'vue-animejs'
import VueRouter from 'vue-router'
import VideoBackground from 'vue-responsive-video-background-player'
//import '@/assets/css/index.css'

Vue.component('video-background', VideoBackground);
Vue.use(VueRouter)
Vue.use(VueAnime)
Vue.use(Vue2Filters)
Vue.use(VueTailwind)

export const eventBus = new Vue();

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')